import * as yup from 'yup';

export const ChapterContentValidation = yup.object({
  chapterId: yup.string('Enter Chapter').required('Name is required'),
  content: yup
    .string('Enter content')
    .required('Content is required'),
});

